import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";

export function useAudioFileURL(dataPointId?: number, filepath?: string) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["audioFileUrlByDataPointIdAndFilepath", dataPointId, filepath],
    queryFn: async () => {
      if (dataPointId && filepath)
        return apiContext.utp2FilesAPIs.getWavByDataPointIdAndFilepath(dataPointId, filepath).then((response) => {
          const file = new File([response], filepath, { type: "audio/wav" });
          return URL.createObjectURL(file);
        });
    },
  });
}
